"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/bundle";
import { Autoplay } from "swiper/modules";

const text = [
  { name: "Routine" },
  { name: "Rules" },
  { name: "Noise" },
  { name: "Barriers" },
];

export default function TestSlideAnimation() {
  return (
    <div className="relative ml-3.5 h-8 lg:ml-6 lg:h-10">
      <svg
        viewBox="0 0 150 60"
        className="absolute -top-[1px] right-[0.6rem] z-20 block h-full w-full scale-y-110 overflow-visible lg:right-4 lg:scale-y-[1.2] 2xl:right-4"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M56.15,64.35 C 94.7,67.56 179,63.62 179,32.96 C 179,7.04 123.43,0 83.74,0 S -8.11,7.04 -8.11,32.08 S 35.55,70.85 129.86,67.56"
          fill="none"
          stroke="white"
          stroke-width="4"
          pathLength="1"
          stroke-dashoffset="0px"
          stroke-dasharray="1px 1px"
        ></path>
      </svg>
      <Swiper
        direction="vertical"
        loop={true}
        speed={2000}
        autoplay={{
          delay: 500,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="mySwiper !-mb-1 h-full w-full"
      >
        {text.map(({ name }, index: number) => (
          <SwiperSlide
            key={index}
            className="h-fit overflow-hidden text-center flex items-center justify-center text-xl text-custom-secondary md:text-2xl lg:text-4xl"
          >
            <span>{name}</span>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
